module.exports = __webpack_public_path__ + "img/OnlineCoursesImage.2942b20f.png";